import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at', 'archived_at'],
    }),
    {
        autoImport: false,

        state() {
            return {
                id: null,
                title: '',
                description: '',
                category: '',
                tags: [],
                status: 'active',
                standard: 'scorm_1_2',
                latest_version_id: null,
                latest_version: null,
                creator: null,
                versions: [],
                created_at: null,
                updated_at: null,
                archived_at: null,
            };
        },
    }
);
